module.exports = __webpack_public_path__ + "files/3a0e70ff526e8792a69fcfc3a5819a0f.png";